import {get} from "../util/Api";
import {setBaseAlert} from "../action/alert";

export const getAlerts = params => dispatch => {
    return new Promise((resolve, reject) => {
        get("alerts", params).then(data => {
            if(data && data.status === "ok") {
                dispatch(setBaseAlert(data.data));
                resolve(data);
            }
            reject();

        }).catch(err => {
            reject(err);
        })
    })
}
